import React from "react";
import { TripOverlay } from "../../../components/trip/TripOverlay";
import { useShopState } from "../../useShell";

/**
 * The night between days, shown while the player's away trip is the
 * drive home (see TruckPrompt / `goHome`). There is nothing to do at
 * home — that's the point — so the card just holds: the TripTheater
 * begins the wake on its own once the truck is off the lot, the
 * SleepSystem runs the whole overnight in one batch, and the arrival
 * roll brings the truck back up the driveway.
 */
export const SleepOverlay: React.FC = () => {
  const gameState = useShopState();
  const asleep = gameState.player.away?.kind === "home";

  if (!asleep) {
    return null;
  }

  return (
    // No Head Home handler: the way out of the night is morning, which
    // comes on its own.
    <TripOverlay label="Home for the night" testId="sleep-overlay">
      <div className="m-auto text-center space-y-2">
        <h2 className="font-condensed font-bold text-2xl uppercase tracking-wide text-paper-manila">
          Home for the night
        </h2>
        <p className="font-typewriter text-sm text-paper-manila/70">
          The shop sits quiet till morning.
        </p>
      </div>
    </TripOverlay>
  );
};
